import React from "react";
import AboutIllustration from "../assets/team-collaboration.svg";

const AboutSection = () => {
  return (
    <section className="bg-white py-20" id="about">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left: Illustration */}
        <div>
          <img
            src={AboutIllustration}
            alt="About Illustration"
            className="w-full h-auto"
          />
        </div>

        {/* Right: About Content */}
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#4C47DC] mb-6">
            About Badami Labs
          </h2>

          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-1">Who We Are</h3>
              <p>
                Badami Labs is a Bangalore-based IT services company delivering
                high-quality, scalable, and innovative software solutions.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-1">Our Mission</h3>
              <p>
                We help businesses transform ideas into market-ready digital products
                through modern technology and design.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-1">Our Approach</h3>
              <p>
                Client-first mindset, collaborative development, and long-term support
                with complete transparency and agility.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
